import { EnquiryRequestService, EnquiryService, ProfileService, WorkpackService } from 'client/services';
import { getEpsgCode } from 'client/utils/helpers/MapConfig/MapConfig';
import { enquiryFeatureFlag } from 'client/utils/constants/frontEndConfig';
import { fetchMyCoverageOnce } from 'client/store/coverageAssetOwnersSlice/coverageAssetOwnersSlice';
import store from 'client/store/store';

const loader = async ({ request }) => {
    const searchParams = (new URL(request.url))?.searchParams;
    const bookmarkId = searchParams?.get('bookmark');
    const enquiryId = searchParams?.get('enquiry');
    const workpackReqId = searchParams?.get('workpack');

    const [
        epsgCode,
        bookmark,
        enquiry
    ] = await Promise.all([
        getEpsgCode(),
        bookmarkId ? ProfileService.getBookmark(bookmarkId) : null,
        enquiryId ? getEnquiryForMap(enquiryId) : (workpackReqId ? getWorkpackAsEnquiry(workpackReqId) : null)
    ]);

    // if the coverage already successfully fetched, this will be a no-op
    store.dispatch(fetchMyCoverageOnce());

    const reloadAOI = Boolean(searchParams?.get('reloadAOI'));

    return { epsgCode, bookmark, enquiry, reloadAOI };
};

async function getWorkpackAsEnquiry (workpackReqId) {
    try {
        const workpackRequest = await WorkpackService.getWorkpackRequest(workpackReqId);
        if (!workpackRequest) {
            return null;
        }

        // Map loader consumers expect an `enquiry`-like object containing geometry (and optional metadata)
        return {
            ...workpackRequest,
            geometry: workpackRequest.geometry
        };
    } catch (error) {
        // Fall back to no enquiry if the workpack cannot be retrieved (e.g. 404/403)
        return null;
    }
}

async function getEnquiryForMap (enquiryId) {
    if (!enquiryId) {
        return null;
    }

    if (enquiryFeatureFlag) {
        try {
            return await EnquiryRequestService.getEnquiryRequest(enquiryId);
        } catch (error) {
            if (error?.response?.status === 404) {
                return null;
            }
            throw error;
        }
    }

    try {
        return await EnquiryService.getEnquiry(enquiryId);
    } catch (error) {
        if (error?.response?.status === 404) {
            return null;
        }
        throw error;
    }
}

export default loader;
